import type { DropDownResult, DynamicFieldComponentProps } from '@myosh/odin-components';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import type { Control, FieldError } from 'react-hook-form';
import type { ExtendedDynamicFormHierarchySettings } from '../../../@types/forms';
import type { HierarchyType, TransformedFormHierarchyTypes } from '../../../@types/hierarchy-fields';
import { forceAssert } from '../../../utils/type-guards';
import HierarchyFieldAdmin from './hierarchy-field-admin.component';

type RecordHierarchyFields = TransformedFormHierarchyTypes | HierarchyType;

export interface HierarchyFieldGroupAdminProps
  extends DynamicFieldComponentProps<Record<string, Array<DropDownResult>>> {
  hierarchySettings?: ExtendedDynamicFormHierarchySettings;
  hierarchyTypes?: Array<TransformedFormHierarchyTypes | HierarchyType>;
  errorObject?: FieldError;
  control?: Control;
}

export function HierarchyFieldGroupAdmin({
  errorObject,
  value = {},
  hierarchyTypes,
  readOnly,
  onChange,
  hierarchySettings,
}: HierarchyFieldGroupAdminProps) {
  const [hierarchyFieldsState, setHierarchyFieldsState] = useState<Array<RecordHierarchyFields>>();

  useEffect(() => {
    if (hierarchyTypes?.length) {
      setHierarchyFieldsState(forceAssert(hierarchyTypes));
    }
  }, [hierarchyTypes]);

  const hierarchyStyles = clsx({ hidden: hierarchySettings?.hiddenInReadMode && readOnly });

  return (
    <>
      <div className={hierarchyStyles}>
        {hierarchyFieldsState?.map((hierarchyField) => {
          return (
            <HierarchyFieldAdmin
              key={hierarchyField.id}
              value={value}
              hierarchyField={hierarchyField}
              readOnly={readOnly}
              errorObject={errorObject}
              onChange={onChange}
            />
          );
        })}
      </div>
    </>
  );
}
